<template>
    <div class="flex py-1 z-90">
        <button class="flex items-center text-sm text-gray-warm-600 hover:text-red-600 leading-none focus:outline-none focus:shadow-none"
            @click.prevent.stop="confirm_archive ? open = true : submit()"
        >
            <i class="far fa-times-circle mr-2 mb-px"></i>

            <span>{{ $t('Archive') }} <span class="hidden sm:inline">{{ $t('this property') }}</span></span>
        </button>

        <transition
          enter-active-class="transition ease-out duration-100"
          enter-class="transform opacity-0"
          enter-to-class="transform opacity-100"
          leave-active-class="transition ease-in duration-100"
          leave-class="transform opacity-100"
          leave-to-class="transform opacity-0"
        >
            <div class="absolute top-0 left-0 flex items-center justify-center w-full h-full z-100"
                style="background-color: rgba(0, 0, 0, .45);"
                v-show="open"
                @click.prevent.stop="open = false"
            >
                <div v-if="open"
                    class="border border-gray-500 bg-white py-5 px-16 relative rounded shadow-xl"
                >
                    <div class="absolute px-3 py-1 text-xl text-gray-400 hover:text-gray-600 right-0 top-0 cursor-pointer"
                        @click.prevent.stop="close"
                    >
                        <i class="far fa-times-circle"></i>
                    </div>

                    <div class="mb-0">
                        <h2 class="text-lg text-center pb-2 text-red-600">
                            {{ $t('Archive this property') }}?
                        </h2>

                        <p class="text-sm text-center pb-4 text-gray-700 mb-0">
                           {{ $t('Once archived, this property will still be visible in the Properties list of your Settings page.') }}
                        </p>

                        <button type="button"
                            class="block bg-red-600 hover:bg-red-700 text-sm text-white hover:text-white uppercase tracking-wider leading-none px-12 py-4 mx-auto"
                            @click.prevent.stop="submit"
                        >
                            {{ $t('Archive') }}
                        </button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        id: {},
        confirm_archive: { default: true },
    },

    data() {
        return {
            open: false,
            status: null,
        }
    },

    methods: {
        close() {
            this.open = false;
            this.status = null;
        },
        submit() {
            axios({
                method: 'post',
                url: '/broker/properties/' + this.id + '/archive',
            })
                .then(response => {
                    this.$emit('archived');

                    if (this.confirm_archive) {
                        window.location.href = '/broker/dashboard';
                    }
                }).catch(error => {
                    console.log(error.response.data);
                });
        },
    },
}
</script>
